import type { IActions, IRules } from '@/models/informalNodeManagerPage';

export interface MergeRulesParams {
  oldRules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']>;
  exhibitName: string;
  action: IActions['set_labels']
    | IActions['replace']
    | IActions['online']
    | IActions['set_title']
    | IActions['set_cover']
    | IActions['add_attr']
    | IActions['delete_attr'];
}

export function mergeRules({
  oldRules,
  exhibitName,
  action,
}: MergeRulesParams): Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> {
  let needHandleRules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> = JSON.parse(JSON.stringify(oldRules));

  if (needHandleRules.some((nhr) => nhr.exhibitName === exhibitName && nhr.operation !== 'activate_theme')) {
    needHandleRules = needHandleRules.map((nhr) => {
      if (nhr.exhibitName === exhibitName && nhr.operation !== 'activate_theme') {
        return {
          ...nhr,
          actions: [
            ...nhr.actions,
            action,
          ],
        };
      }

      return nhr;
    });
  } else {
    const alterRule: IRules['alter'] = {
      operation: 'alter',
      exhibitName: exhibitName,
      actions: [action],
      text: '',
    };
    needHandleRules = [
      ...needHandleRules,
      alterRule,
    ];
  }

  needHandleRules.sort((a) => {
    return a.exhibitName === exhibitName ? -1 : 0;
  });

  return needHandleRules;
}
